var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ui-panel",
    {
      directives: [
        {
          name: "spinner",
          rawName: "v-spinner",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "section",
      class: { collapsable: _vm.collapsible, open: _vm.open },
      attrs: { padding: false },
    },
    [
      _c(
        "div",
        {
          staticClass: "section-title",
          on: {
            click: function ($event) {
              $event.stopPropagation()
              return _vm.$emit("toggle")
            },
          },
        },
        [
          _c("div", { staticClass: "left" }, [
            _c("div", { staticClass: "collapse-indicator" }, [
              _c("i", { staticClass: "magicon-arrow-down-1" }),
            ]),
            _c("h2", [_vm._v("Vak " + _vm._s(_vm.section.name))]),
            _c("span", { staticClass: "efficiency" }, [
              _vm._v(
                "(Rendement: " +
                  _vm._s(_vm._f("number")(_vm.section.efficiency * 100)) +
                  "%)"
              ),
            ]),
            _vm.totalSowingDensity != null
              ? _c("span", { staticClass: "efficiency" }, [
                  _vm._v(
                    "(Zaaidichtheid: " +
                      _vm._s(_vm._f("number")(_vm.totalSowingDensity)) +
                      " mTon/ha)"
                  ),
                ])
              : _vm._e(),
          ]),
          _c(
            "div",
            { staticClass: "right" },
            [
              _vm.actionOptions.length > 1
                ? _c(
                    "div",
                    { staticClass: "action-filter" },
                    [
                      _c("ui-dropdown", {
                        attrs: {
                          options: _vm.actionOptions,
                          empty: "Alle acties",
                        },
                        model: {
                          value: _vm.selectedActionType,
                          callback: function ($$v) {
                            _vm.selectedActionType = $$v
                          },
                          expression: "selectedActionType",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                { staticClass: "date-navigator" },
                [
                  _c("ui-button", {
                    staticClass: "prev",
                    attrs: {
                      color: "light",
                      icon: "magicon-arrow-left-1",
                      disabled: !_vm.canNavigateDate(-1),
                    },
                    on: {
                      click: function ($event) {
                        return _vm.navigateDate(-1)
                      },
                    },
                  }),
                  _c("span", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.dateTitle)),
                  ]),
                  _c("ui-button", {
                    staticClass: "next",
                    attrs: {
                      color: "light",
                      icon: "magicon-arrow-right-1",
                      disabled: !_vm.canNavigateDate(1),
                    },
                    on: {
                      click: function ($event) {
                        return _vm.navigateDate(1)
                      },
                    },
                  }),
                ],
                1
              ),
              _vm.editable && _vm.cohort
                ? [
                    !_vm.cohort.endDate
                      ? _c(
                          "ui-button",
                          {
                            staticClass: "button-right",
                            attrs: { color: "negative" },
                            on: {
                              click: function ($event) {
                                return _vm.closeCohort()
                              },
                            },
                          },
                          [_vm._v("Cohort afsluiten")]
                        )
                      : _c(
                          "ui-button",
                          {
                            staticClass: "button-right",
                            attrs: { disabled: "" },
                          },
                          [_vm._v("Cohort afgesloten")]
                        ),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ]
      ),
      _c(
        "ui-table",
        {
          staticClass: "action-table",
          attrs: {
            placeholder: _vm.section && !_vm.actions.length,
            clickable: "",
          },
        },
        [
          _c(
            "ui-table-header",
            [
              _c("ui-th", { attrs: { weight: "1.5" } }, [_vm._v("Datum")]),
              _c("ui-th", { attrs: { weight: "2" } }, [_vm._v("Actie")]),
              _c("ui-th", { attrs: { weight: "1" } }, [_vm._v("Visgebied")]),
              _c("ui-th", { attrs: { weight: "1" } }, [_vm._v("Bruto")]),
              _c("ui-th", { attrs: { weight: "1" } }, [_vm._v("Netto")]),
              _c("ui-th", { attrs: { weight: "1" } }, [_vm._v("Gewicht")]),
              _c("ui-th", { attrs: { weight: "1" } }, [_vm._v("Tarra")]),
              _c("ui-th", { attrs: { weight: "1" } }, [_vm._v("Bustal")]),
              _c("ui-th", { attrs: { weight: "1" } }, [_vm._v("Stukstal")]),
              _c("ui-th", { attrs: { weight: "1" } }, [
                _vm._v("Zaaidichtheid"),
              ]),
              _c("ui-th", { attrs: { weight: "1" } }, [_vm._v("Visuren")]),
              _c("ui-th", { attrs: { weight: "1" } }, [_vm._v("Foto's")]),
              _c("ui-th", { attrs: { weight: "1" } }),
            ],
            1
          ),
          _vm._l(_vm.actions, function (action) {
            return _c(
              "ui-tr",
              {
                key: `${action.__typename}_${action.id}`,
                attrs: { click: "detail" },
              },
              [
                _c("td", [
                  _vm._v(_vm._s(_vm._f("date")(action.date, "DD-MM-YYYY"))),
                ]),
                _c("td", [
                  _vm._v(
                    _vm._s(_vm._f("actionTypeTitle")(action.__typename, action))
                  ),
                ]),
                _c(
                  "td",
                  [
                    action.fishingArea
                      ? [_vm._v(_vm._s(action.fishingArea))]
                      : [_vm._v("-")],
                  ],
                  2
                ),
                _c(
                  "td",
                  [
                    action.brutoWeight
                      ? [
                          _vm._v(
                            _vm._s(_vm._f("number")(action.brutoWeight)) +
                              " mTon"
                          ),
                        ]
                      : [_vm._v("-")],
                  ],
                  2
                ),
                _c(
                  "td",
                  [
                    action.nettoWeight
                      ? [
                          _vm._v(
                            _vm._s(_vm._f("number")(action.nettoWeight)) +
                              " mTon"
                          ),
                        ]
                      : [_vm._v("-")],
                  ],
                  2
                ),
                _c(
                  "td",
                  [
                    action.brutoWeight
                      ? [
                          _vm._v(
                            _vm._s(_vm._f("number")(action.brutoWeight * 100)) +
                              " kg"
                          ),
                        ]
                      : [_vm._v("-")],
                  ],
                  2
                ),
                _c(
                  "td",
                  [
                    action.tarra
                      ? [_vm._v(_vm._s(_vm._f("number")(action.tarra)) + "%")]
                      : [_vm._v("-")],
                  ],
                  2
                ),
                _c("td", [
                  _vm._v(
                    _vm._s(_vm._f("empty")(_vm._f("number")(action.bustal)))
                  ),
                ]),
                _c("td", [
                  _vm._v(
                    _vm._s(_vm._f("empty")(_vm._f("number")(action.stukstal)))
                  ),
                ]),
                _c(
                  "td",
                  [
                    action.brutoWeight || action.nettoWeight
                      ? [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm._f("number")(
                                  (action.brutoWeight || action.nettoWeight) /
                                    _vm.section.size
                                )
                              ) +
                              " mTon/ha "
                          ),
                        ]
                      : [_vm._v("-")],
                  ],
                  2
                ),
                _c(
                  "td",
                  [
                    action.fishingDuration
                      ? [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm._f("empty")(
                                  _vm._f("number")(
                                    action.fishingDuration.duration
                                  )
                                )
                              ) +
                              " min "
                          ),
                        ]
                      : [_vm._v("-")],
                  ],
                  2
                ),
                _c("td", [_vm._v(_vm._s(action.actionImages.items.length))]),
                _c(
                  "td",
                  {
                    staticClass: "actions",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                      },
                    },
                  },
                  [
                    _c("ui-link", {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: "Details",
                          expression: "'Details'",
                        },
                      ],
                      attrs: { icon: "entypo-eye", action: "detail" },
                      on: {
                        click: function ($event) {
                          return _vm.openActionDetailModal(action)
                        },
                      },
                    }),
                    _vm.editable && _vm.getEditRoute(action)
                      ? _c("ui-link", {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "Wijzigen",
                              expression: "'Wijzigen'",
                            },
                          ],
                          attrs: {
                            icon: "magicon-edit",
                            to: _vm.getEditRoute(action),
                          },
                        })
                      : _vm._e(),
                    _vm.deletable
                      ? _c("ui-link", {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "Verwijderen",
                              expression: "'Verwijderen'",
                            },
                          ],
                          attrs: { icon: "magicon-trash" },
                          on: {
                            click: function ($event) {
                              return _vm.deleteAction(action)
                            },
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            )
          }),
        ],
        2
      ),
      _vm.actionsWithImages.length > 0
        ? _c(
            "section",
            { staticClass: "photos" },
            [
              _c("h2", { staticClass: "title" }, [_vm._v("Foto's")]),
              _vm._l(_vm.actionsWithImages, function (n) {
                return _c("div", { staticClass: "actions-container" }, [
                  _c("h3", { staticClass: "date" }, [
                    _vm._v(
                      _vm._s(_vm._f("date")(n.date, "DD MMMM YYYY")) +
                        " – " +
                        _vm._s(_vm._f("actionTypeTitle")(n.__typename, n))
                    ),
                  ]),
                  _c(
                    "div",
                    { staticClass: "image-container" },
                    _vm._l(n.actionImages.items, function (image, index) {
                      return _c("img", {
                        staticClass: "image",
                        attrs: { src: image.url },
                        on: {
                          click: function ($event) {
                            return _vm.openPhotoViewer(n, image, index)
                          },
                        },
                      })
                    }),
                    0
                  ),
                ])
              }),
            ],
            2
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }